<template>
    <div
        v-if="loading"
        class="absolute left-0 bottom-0 flex w-full bg-transparent h-0.5"
    >
        <div class="w-full h-full z-100 loader-line before:bg-primary before:h-full"></div>
    </div>
</template>

<script setup>
defineProps({
    loading: {
        type: Boolean,
        default: false,
    },
    position: {
        type: String,
        default: 'absolute',
    },
})
</script>
